import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';
import moment from 'moment';

const {
  UPDATE_APPOINTMENT_END_TIME_REQUEST,
  UPDATE_APPOINTMENT_END_TIME_SUCCESS,
  UPDATE_APPOINTMENT_END_TIME_FAILURE,
  UPDATE_APPOINTMENT_END_TIME_LOADING,
  GET_DATA_THERAPY_PLANNING_REQUEST_2_0,
  GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0,
  GET_7DAY_LOOK_BACK_SUM_REQUEST,
} = therapyPlanningAction;

function* updateAppointmentEndTime(action: any): SagaReturnType<any> {
  try {
    yield put({ type: UPDATE_APPOINTMENT_END_TIME_LOADING });
    const response = yield call(
      therapyPlanningService.updateAppointmentEndTime,
      action?.payload
    );
    if (response?.status === 200) {
      yield put({ type: UPDATE_APPOINTMENT_END_TIME_SUCCESS, payload: response?.data });

      const refreshContext = action?.payload?.refreshContext;
      if (refreshContext?.patientId) {
        yield put({
          type: GET_DATA_THERAPY_PLANNING_REQUEST_2_0,
          payload: {
            patientId: refreshContext?.patientId,
            therapyType: refreshContext?.discipline,
            groupType: refreshContext?.type,
            source: 'GET_SINGLE_CELL',
            params: {
              providerId: action?.payload?.providerId,
              startDate: refreshContext?.localDate,
              endDate: refreshContext?.localDate,
            },
          },
        });

        yield put({
          type: GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0,
          payload: {
            patientId: refreshContext?.patientId,
            therapyType: refreshContext?.discipline,
            groupType: refreshContext?.type,
            source: 'GET_SINGLE_CELL',
            params: {
              providerId: action?.payload?.providerId,
              startDate: refreshContext?.weekStartDate,
              endDate: refreshContext?.weekEndDate,
              discipline: refreshContext?.discipline,
            },
          },
        });

        yield put({
          type: GET_7DAY_LOOK_BACK_SUM_REQUEST,
          payload: {
            patientId: refreshContext?.patientId,
            therapyType: refreshContext?.discipline,
            groupType: refreshContext?.type,
            source: 'GET_SINGLE_CELL',
            params: {
              providerId: action?.payload?.providerId,
              startDate: refreshContext?.weekStartDate,
              endDate: refreshContext?.weekEndDate,
              discipline: refreshContext?.discipline,
              today: moment().format('YYYY-MM-DD'),
            },
          },
        });
      }
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: UPDATE_APPOINTMENT_END_TIME_FAILURE, payload: error });
  }
}

function* updateAppointmentEndTimeSaga() {
  yield takeEvery(UPDATE_APPOINTMENT_END_TIME_REQUEST, updateAppointmentEndTime);
}

export default updateAppointmentEndTimeSaga;
